import { useTranslation } from "react-i18next";
import { TWclassNames } from "../../utils/Div";
import { status } from "../../Utils";

export const orderStatusOptions = [
  {
    id: "NOT_CHOSEN",
    value: "NOT_CHOSEN",
    title: "Not chosen",
    label: "Not chosen",
  },
  {
    id: "NEW",
    value: "NEW",
    title: "New",
    label: "New",
  },
  {
    id: "CONFIRMATION_SENT",
    value: "CONFIRMATION_SENT",
    title: "Order Confrimation Sent",
    label: "Order Confrimation Sent",
  },
  {
    id: "READY_FOR_PICKING",
    value: "READY_FOR_PICKING",
    title: "Ready to be picked",
    label: "Ready to be picked",
  },
  { id: "PICKED", value: "PICKED", title: "Picked", label: "Picked" },
  { id: "PACKED", value: "PACKED", title: "Packed", label: "Packed" },
  {
    id: "READY_FOR_SHIPPING",
    value: "READY_FOR_SHIPPING",
    title: "Ready to be shipped",
    label: "Ready to be shipped",
  },
  {
    id: "READY_FOR_INVOICING",
    value: "READY_FOR_INVOICING",
    title: "Ready to be invoiced",
    label: "Ready to be invoiced",
  },
  { id: "INVOICED", value: "INVOICED", title: "Invoiced", label: "Invoiced" },
  {
    id: "CANCELLED",
    value: "CANCELLED",
    title: "Cancelled",
    label: "Cancelled",
  },
];

export const OrderStatus = ({ order }) => {
  const { t } = useTranslation();

  return (
    <span
      className={TWclassNames(
        order?.status && !order?.is_invoiced
          ? status[order?.status]?.class
          : "",
        order?.is_invoiced && "bg-green-100 text-green-800",
        "inline-flex rounded-full px-2 text-xs font-semibold leading-5"
      )}
    >
      {order?.is_invoiced ? (
        <span>Fakturert</span>
      ) : (
        <>
          {order.status ? (
            <span> {t(status[order?.status]?.label || order?.status)}</span>
          ) : (
            <span className="bg-gray-100 inline-flex rounded-full px-2 text-xs font-semibold leading-5">
              {t("None")}
            </span>
          )}
        </>
      )}
    </span>
  );
};

export const ordersViewsOptions = [
  { id: "active", value: "ACTIVE", label: "Aktive" },
];
